import React, { Component } from "react";
import { PreviousButton } from "../components/PreviousButton";
import { LenderRow } from "../components/LenderRow";
import { NumberInput } from "../components/NumberInput";
import { ErrorBox } from "../components/ErrorBox";
import { NextButton } from "../components/NextButton";

interface IProps {
  gtmEvent(): void;
  nextStep(): void;
  prevStep(): void;
  updateLead(props: any): void;
  lvtotalsavings?: number;
  lvmonthlyrepayments?: number;
  mortgageamount: number;
  consent: boolean;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  lvtotalsavings?: number;
  lvmonthlyrepayments?: number;
}

export class LVFinancialCommitments extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      lvtotalsavings: this.props.lvtotalsavings,
      lvmonthlyrepayments: this.props.lvmonthlyrepayments,
    };
  }

  componentDidMount(): void {
    this.props.gtmEvent();
  }

  nextStep() {
    const errors: string[] = [];
    if (!this.state.lvtotalsavings) {
      errors.push("Current savings balance is required");
    }
    // if (!this.state.consent) {
    //     errors.push("Consent is required");
    // }
    if (errors.length > 0) {
      this.setState({ hasError: true, errors });
      return;
    }
    this.setState({ hasError: false, errors: [] });
    this.props.nextStep();
  }

  render() {
    return (
      <header className="App-header">
        <h1>And finally, your Current Savings</h1>
        <div className="wrapper">
          <div className="row">
            <div className="column2 justify-c">
              <NumberInput
                id="lvtotalsavings"
                key="lvtotalsavings"
                label={<>Current Savings Balance</>}
                value={this.props.lvtotalsavings}
                classes={
                  this.state.hasError && !this.state.lvtotalsavings ? "e" : ""
                }
                onChange={(e) => {
                  this.setState({ lvtotalsavings: e.target.value });
                  this.props.updateLead({ lvtotalsavings: e.target.value });
                }}
              />
            </div>{" "}
            <br />
            {/* <div className='column2 justify-s'>
                            <NumberInput
                                id='lvmonthlyrepayments'
                                key='lvmonthlyrepayments'
                                label={<>Monthly Repayments</>}
                                value={this.props.lvmonthlyrepayments}
                                classes={this.state.hasError && !this.state.lvmonthlyrepayments ? "e" : ""}
                                onChange={(e) => { this.setState({lvmonthlyrepayments: e.target.value}); this.props.updateLead({lvmonthlyrepayments:e.target.value}); }} />
                        </div> */}
          </div>

          {/* {(this.props.mortgageamount < 180000) && (<>
                    <label htmlFor='consent'>We have sent our Terms of Business and Privacy Notice to your email</label> 
                    { 
                        <div className='row'>
                            <div className='d-column'>
                            <input 
                                id='consent' 
                                type='checkbox' 
                                name='consent'
                                checked={this.props.consent}
                                className={this.state.hasError && !this.state.consent ? "e" : ""}
                                onChange={(e) => { this.setState({consent: e.target.checked}); this.props.updateLead({consentGiven: e.target.checked}); }} />
                            <label htmlFor='consent'>I consent for doddl to process the information I provided, and to contact me in relation to my mortgage and associated insurances as per the <a href='https://doddl.ie/privacy-notice/' target='_blank'>doddl Privacy Notice</a> and <a href='https://doddl.ie/terms-conditions/' target='_blank'>Terms of Business</a></label>
                            </div>
                        </div>
                    }</>)} */}

          {this.state.hasError && <ErrorBox errors={this.state.errors!} />}
          <div className="row">
            <div className="button-group">
              <PreviousButton onClick={() => this.props.prevStep()} />
              <NextButton customLabel="Next" onClick={() => this.nextStep()} />
            </div>
          </div>
          <div className="row mt-2">
            <LenderRow />
          </div>
        </div>
      </header>
    );
  }
}
